





































































import { Component, Prop, Vue } from 'vue-property-decorator';
import FormProvider from '@shared/components/forms/form-provider.vue';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import Input from '@shared/components/forms/inputs/input/input.vue';
import Select from '@shared/components/forms/inputs/select/select.vue';
import RandomKeyInput from '../random-key-input.vue';
import { AccessControlConfigInterface } from '@core/interfaces/access-control-config-interface';

@Component({
  name: 'bc-access-control-config-form',
  components: {
    'bpc-form-provider': FormProvider,
    'bc-input': Input,
    'bc-select': Select,
    'bc-random-key-input': RandomKeyInput,
  },
})
export default class AccessControlConfigForm extends Vue {
  $refs!: {
    formProvider: InstanceType<typeof FormProvider> & {
      errorsObject: object;
      saveEntity(formModel: AccessControlConfigInterface): Promise<BPCGenericApiResponse>;
      resetErrorObject(): void;
      manageSaveErrors(error): void;
    };
  };

  // PROPS
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  readonly value;

  // LIFECYCLE
  mounted() {
    this.getAccessControlConfig();
  }

  // COMPUTED
  get formModel() {
    return this.value;
  }
  set formModel(value) {
    this.$emit('input', value);
  }
  get tenantId(): number {
    return this.$store.getters['tenant/selectedTenantId'];
  }

  get fieldsConfig() {
    return {
      access_control_service: {
        rules: ['required'],
        fieldPath: 'access_control_service',
        fieldReadPath: 'access_control_service',
        name: 'access_control_service',
        label: 'global.access_control_service.label',
        options: [
          {
            text: this.$t('global.fields.access_control_service.none.label'),
            value: null,
          },
          {
            text: this.$t('global.fields.access_control_service.finddoc.label'),
            value: 'finddoc',
          },
          {
            text: this.$t('global.fields.access_control_service.internal.label'),
            value: 'internal',
          },
        ],
        id: 'access_control_service',
        defaultValue: null,
        wrapperAttributes: {
          class: {
            'col-md-12': true,
          },
        },
        labelAttributes: {
          cols: 3,
        },
      },
      access_control_url: {
        rules: ['required'],
        wrapperAttributes: {
          class: {
            'col-md-12': true,
          },
        },
        labelAttributes: {
          cols: 3,
        },
        label: 'global.access_control_url.label',
      },
      access_control_key: {
        rules: ['required'],
        wrapperAttributes: {
          class: {
            'col-md-12': true,
          },
        },
        labelAttributes: {
          cols: 3,
        },
        label: 'global.access_control_key.label',
      },
      early_access_delay: {
        rules: ['required'],
        wrapperAttributes: {
          class: {
            'col-md-12': true,
          },
        },
        labelAttributes: {
          cols: 3,
        },
        label: 'global.early_access_delay.label',
        fieldAttributes: {
          type: 'number',
          step: '1',
        },
      },
    };
  }

  // METHODS
  async getAccessControlConfig() {
    const path = this.$bpcApiRouteHelper.getApiPath(`access-control-config`);
    const response = await this.$bpcApi.get(path).toPromise();
    this.formModel = response.data;
    this.$emit('config-loaded', response.data);
  }

  saveEntity() {
    this.$refs.formProvider.saveEntity(this.formModel);
  }

  onEntitySaved(e) {
    this.$emit('entity-saved', e);
  }

  onEntityErrorSaving(e) {
    this.$bpcMessage.showErrorMessage({ text: 'core.superadmin_form_update_errors' });
    this.$emit('entity-error-saving', e);
  }

  onSavingEntity(event) {
    this.$emit('saving-entity', event);
  }

  onModelLoaded(event) {
    this.$emit('model-loaded', event);
  }

  prepareToSave(model) {
    return model;
  }
}
